import { BaseUserSection } from "@cmde/shadcn";
import { useAuth } from "@/contexts/auth";

export const AppUserSection = () => {
  const { user } = useAuth();
  if (!user) return null;
  return <BaseUserSection name={user.name} email={user.email} image={user.picture} />;
};
